import React from "react";
import { Segment } from "semantic-ui-react";
import BookingCard from "./BookingCard";

const data = [
  {
    iconName: "clock",
    header: "Saves you time",
    content:
      "Maid To Clean Jax helps you live smarter, giving you time to focus on what’s most important."
  },
  {
    iconName: "shield",
    header: "Safety first",
    content:
      "We rigorously vet all of our Cleaners, who undergo identity checks as well as in-person interviews."
  },
  {
    iconName: "thumbs up",
    header: "Only the best quality",
    content:
      "Our skilled professionals go above and beyond on every job. Cleaners are rated and reviewed after each task."
  },
  {
    iconName: "check",
    header: "Easy to get help",
    content:
      "We bring our own safe supplies. Let us know of any special requests and we’ll make it happen."
  },
  {
    iconName: "chat",
    header: "Seamless communication",
    content:
      "Online commuication makes it easy for you to stay in touch with your cleaners."
  },
  {
    iconName: "visa",
    header: "Cash-Free payment",
    content: "Pay securely online only when the cleaning is complete."
  }
];

export const WhyToBook = props => {
  return (
    <Segment>
      {data.map((obj, index) => {
        const { header, content, iconName } = obj;
        return (
          <BookingCard
            header={header}
            content={content}
            key={index}
            iconName={iconName}
          />
        );
      })}
    </Segment>
  );
};

export default WhyToBook;



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/WhyToBook.jsx